<template>
  <div class="pages" :style="{ minHeight: height + 'px' }">
    <navTop></navTop>
    <div class="box">
      <div class="box-main">
        <div class="box-main-reason">
          <div class="box-main-reason-left">
            Please select the after-sales reason
          </div>
          <select class="box-main-reason-right" @change="fnselect($event)">
            <option v-for="(item, index) in cancelList" :key="index">
              {{ item.name }}
            </option>
          </select>
        </div>
        <p class="box-main-explain">说明</p>
        <textarea
            class="box-main-textarea"
            v-model="content"
            placeholder="Please enter more reasons"
        ></textarea>
        <div class="box-main-btn" @click="subimt">Determine</div>
      </div>
    </div>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import navFooter from '../../components/navFooter.vue';
export default {
  name: 'applyAftersales',
  components: {
    navTop,
    navFooter
  },
  data() {
    return {
      height: '',
      content: '',
      text: '',
      cancelList: [],
      id: ''
    };
  },
  created() {
    if (!sessionStorage.getItem('uid')) {
      this.$router.push({ path: '/' });
    } else {
      this.id = this.$route.query.id;
      this.height = window.innerHeight;
      this.getCancelreason();
    }
  },
  methods: {
    getCancelreason() {
      let data = {
        type: 2
      };
      this.$api.cancelreason(data).then(res => {
        console.log(res);
        if (res.result == 0) {
          this.cancelList = res.dataList;
          this.text = res.dataList[0].name;
        }
      });
    },
    fnselect(e) {
      this.text = e.target.value;
    },
    subimt() {
      if (this.content == '') {
        this.$message({
          message: 'Please fill in the after-sales reasons',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      let data = {
        id: this.id,
        type: 2,
        cancelReason: this.text,
        cancelDetail: this.content
      };
      this.$api.cancel(data).then(res => {
        console.log(res);
        if (res.result == 0) {
          this.$router.push({ path: '/success', query: { num: 3 } });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;
    padding-top: 30px;
    padding-bottom: 80px;
    box-sizing: border-box;

    .box-main {
      width: 100%;
      border-radius: 38px;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      border: 1px solid $blue-primary-rgba;
      box-shadow: 0 0 40px $blue-glow;
      padding: 60px 150px 100px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .box-main-reason {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        flex-wrap: wrap;
        gap: 20px;

        .box-main-reason-left {
          font-size: 22px;
          color: #c0e4ff;
          line-height: 1.2em;
          white-space: nowrap;
          text-shadow: 0 0 5px $blue-glow;
        }

        .box-main-reason-right {
          outline: none;
          width: 400px;
          height: 50px;
          background: rgba(27, 168, 232, 0.1);
          border: 1px solid $blue-primary;
          border-radius: 8px;
          padding: 0 20px;
          box-sizing: border-box;
          font-weight: 400;
          color: $blue-primary;
          line-height: 50px;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 0 15px $blue-glow inset;

          &:hover {
            background: rgba(27, 168, 232, 0.15);
            box-shadow: 0 0 20px $blue-primary inset;
          }

          option {
            background: $blue-dark;
            color: $blue-primary;
          }
        }
      }

      .box-main-explain {
        width: 100%;
        font-size: 22px;
        color: #c0e4ff;
        line-height: 1.2em;
        margin-top: 40px;
        text-align: center;
        text-shadow: 0 0 5px $blue-glow;
      }

      .box-main-textarea {
        margin-top: 30px;
        width: 100%;
        height: 159px;
        background: rgba(27, 168, 232, 0.1);
        border: 1px solid $blue-primary;
        border-radius: 10px;
        outline: none;
        resize: none;
        padding: 17px 20px;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 400;
        color: $blue-primary;
        line-height: 1.5;
        transition: all 0.3s ease;
        box-shadow: 0 0 15px $blue-glow inset;

        &:focus {
          box-shadow: 0 0 25px $blue-primary inset;
          background: rgba(27, 168, 232, 0.15);
        }
      }

      .box-main-textarea::-webkit-input-placeholder {
        color: rgba(27, 168, 232, 0.6);
      }

      .box-main-btn {
        width: 100%;
        height: 60px;
        background: linear-gradient(
                90deg,
                rgba(27, 168, 232, 0.8) 0%,
                rgba(27, 168, 232, 0.6) 100%
        );
        font-size: 24px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        margin: 50px auto 0;
        border-radius: 30px;
        border: 1px solid $blue-primary;
        box-shadow: 0 0 20px $blue-glow;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 30px $blue-primary;
          background: linear-gradient(
                  90deg,
                  rgba(27, 168, 232, 0.9) 0%,
                  rgba(27, 168, 232, 0.7) 100%
          );
        }

        &:active {
          transform: translateY(0);
        }
      }
    }
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .box {
      .box-main {
        padding: 50px 80px 80px;

        .box-main-reason {
          .box-main-reason-left {
            font-size: 20px;
          }

          .box-main-reason-right {
            width: 350px;
          }
        }

        .box-main-explain {
          font-size: 20px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    .box {
      .box-main {
        padding: 40px 30px 60px;

        .box-main-reason {
          flex-direction: column;
          align-items: flex-start;

          .box-main-reason-left {
            font-size: 18px;
            white-space: normal;
          }

          .box-main-reason-right {
            width: 100%;
            margin-left: 0;
          }
        }

        .box-main-explain {
          font-size: 18px;
          text-align: left;
        }

        .box-main-textarea {
          height: 140px;
          font-size: 14px;
        }

        .box-main-btn {
          height: 50px;
          line-height: 50px;
          font-size: 20px;
        }
      }
    }
  }
}
</style>